/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  productgroup: {
    '& .divider': {
      margin: '4px auto'
    },
    '& .mode': {
      width: '200px',
      background: '#F5F5F5',
      borderRadius: '4px',
      justifyContent: 'center',
      alignItems: 'center',
      height: '44px',
      '& > div': {
        height: '32px', 
        width: '90px', 
        padding: '8px', 
        textAlign: 'center', 
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'ease-in background 0.10s',
        '&.active-true': {
          background: '#FFF',
        }
      }
    },
    '& .formelement': {
      zIndex: 0
    },
    '& .icon': {
      color: '#7E92B8'
    },
    '& .name-productgrouplabel': {
      width: '90%'
    },
    '& .disabled-true': {
      pointerEvents: 'none',
      opacity: 0.5
    },
    '& .globalsave': {
      position: 'sticky',
      background: '#fff',
      bottom: 0,
      width: '100%',
      padding: '16px',
      boxShadow: '0em 0em 1.5em rgba(172, 217, 251, 0.2)',
      zIndex: 999
    }
  }
});
